"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteStudyUserApiKeyResponse = exports.UpdateStudyUserApiKeyResponse = exports.CreateStudyUserApiKeyResponse = exports.GetStudyUserApiKeyResponse = exports.GetStudyUserActivateStatusResponse = exports.GetStudyActionAuditsResponse = exports.UpdateStudyMailTemplateResponse = exports.CreateStudyMailTemplateResponse = exports.GetStudyMailTemplateResponse = exports.GetStudiesResponse = exports.NotifyStudyUserAddedResponse = exports.UpdateStudyUserResponse = exports.RestoreStudyUserResponse = exports.DeleteStudyUserResponse = exports.CreateStudyUserResponse = exports.GetStudyUserResponse = exports.GetStudySummaryResponse = exports.GetStudySummaryStatusResponse = exports.GetStudySpecResponse = exports.UpdateStudyResponse = exports.GetStudiesSummaryResponse = exports.GetStudyResponse = exports.CreateStudyResponse = void 0;
class CreateStudyResponse {
}
exports.CreateStudyResponse = CreateStudyResponse;
class GetStudyResponse {
}
exports.GetStudyResponse = GetStudyResponse;
class GetStudiesSummaryResponse {
}
exports.GetStudiesSummaryResponse = GetStudiesSummaryResponse;
class UpdateStudyResponse {
}
exports.UpdateStudyResponse = UpdateStudyResponse;
/** @deprecated 2024.06.30 Rest로 이관 및 API 분리 */
class GetStudySpecResponse {
}
exports.GetStudySpecResponse = GetStudySpecResponse;
class GetStudySummaryStatusResponse {
}
exports.GetStudySummaryStatusResponse = GetStudySummaryStatusResponse;
class GetStudySummaryResponse {
}
exports.GetStudySummaryResponse = GetStudySummaryResponse;
class GetStudyUserResponse {
}
exports.GetStudyUserResponse = GetStudyUserResponse;
class CreateStudyUserResponse {
}
exports.CreateStudyUserResponse = CreateStudyUserResponse;
class DeleteStudyUserResponse {
}
exports.DeleteStudyUserResponse = DeleteStudyUserResponse;
class RestoreStudyUserResponse {
}
exports.RestoreStudyUserResponse = RestoreStudyUserResponse;
class UpdateStudyUserResponse {
}
exports.UpdateStudyUserResponse = UpdateStudyUserResponse;
class NotifyStudyUserAddedResponse {
}
exports.NotifyStudyUserAddedResponse = NotifyStudyUserAddedResponse;
class GetStudiesResponse {
}
exports.GetStudiesResponse = GetStudiesResponse;
class GetStudyMailTemplateResponse {
}
exports.GetStudyMailTemplateResponse = GetStudyMailTemplateResponse;
class CreateStudyMailTemplateResponse {
}
exports.CreateStudyMailTemplateResponse = CreateStudyMailTemplateResponse;
class UpdateStudyMailTemplateResponse {
}
exports.UpdateStudyMailTemplateResponse = UpdateStudyMailTemplateResponse;
class GetStudyActionAuditsResponse {
}
exports.GetStudyActionAuditsResponse = GetStudyActionAuditsResponse;
class GetStudyUserActivateStatusResponse {
}
exports.GetStudyUserActivateStatusResponse = GetStudyUserActivateStatusResponse;
class GetStudyUserApiKeyResponse {
}
exports.GetStudyUserApiKeyResponse = GetStudyUserApiKeyResponse;
class CreateStudyUserApiKeyResponse {
}
exports.CreateStudyUserApiKeyResponse = CreateStudyUserApiKeyResponse;
class UpdateStudyUserApiKeyResponse {
}
exports.UpdateStudyUserApiKeyResponse = UpdateStudyUserApiKeyResponse;
class DeleteStudyUserApiKeyResponse {
}
exports.DeleteStudyUserApiKeyResponse = DeleteStudyUserApiKeyResponse;
//# sourceMappingURL=study.js.map